<template>
  <div class="mx-auto my-2">
    <v-card class="mx-2" flat>
      <v-card-title>
        Accreditors
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Search"
            single-line
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
            v-if="canCreateAccreditor"
            class="teal white--text"
            depressed
            @click="AddAccreditor()"
        >
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Add Accreditor</span>
        </v-btn>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="accreditors.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="accreditors.count"
          class="elevation-1"
          loading-text="Loading... please wait"
      >
        <template v-slot:[`item.accreditorName`]="{ item }">
          <label for="item">{{
              item.accreditorName ? item.accreditorName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditorGeolocation`]="{ item }">
          <label for="item">{{
              item.accreditorGeolocation ? item.accreditorGeolocation : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accredatorOwnership.name`]="{ item }">
          <label for="item">{{
              item.accredatorOwnership ? item.accredatorOwnership.name : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditationCode`]="{ item }">
          <label for="item">{{
              item.accreditationCode ? item.accreditationCode : "-"
            }}</label>
        </template>
        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip :color="getColor(item.isActive)" dark>
            {{ item.isActive == true ? "Active" : "Not Active" }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-if="canViewAccreditor" v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="viewAccreditor(item)"
                  v-on="on"
              >mdi-eye
              </v-icon
              >
            </template>
            <span>View Accreditor</span>
          </v-tooltip>
          |
          <v-tooltip bottom>
            <template v-if="canEditAccreditor(item.createdById, item.id)" v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="editAccreditor(item)"
                  v-on="on"
              >mdi-circle-edit-outline
              </v-icon
              >
            </template>
            <span>Edit Accreditor</span>
          </v-tooltip>
          |
          <v-tooltip bottom>
            <template v-if="canRenewAccreditor()" v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="renewAccreditor(item)"
                  v-on="on"
              >mdi-autorenew
              </v-icon
              >
            </template>
            <span>Renew Accreditor</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <template>
      <v-dialog v-model="dialog" persistent width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >

          <v-divider></v-divider>
          <HrdAddAccreditor
              v-if="dialog"
              :accreditor="accreditor"
              @close="closeDialog()"
              @registerOrUpdateAccreditor="registerOrUpdateAccreditor"
          ></HrdAddAccreditor>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="detailDialog" persistent width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >
            {{ title }}

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>
          <HrdDetailAccreditor
              v-if="detailDialog"
              :accreditor="accreditor"
          ></HrdDetailAccreditor>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="renewalDialog" persistent width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >

          <v-divider></v-divider>
          <v-card
              class="flex flex-wrap my-2 mb-6 py-4 justify-center"
              outlined
              style="background-color: whitesmoke"
          >
            <div class="w-full px-3 md:mb-0">
              <v-container>
                <v-row>
                  <div class="w-full md:w-1/2 px-3 mb-6 required">
                    <label
                        class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
                    >Renew Date:
                    </label>
                    <validation-provider v-slot="{ errors }" rules="required">
                      <v-menu
                          ref="menu"
                          v-model="startMenu"
                          :close-on-content-click="false"
                          max-width="290px"
                          min-width="290px"
                          offset-y
                          transition="scale-transition"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="formValues.accreditedDate"
                              label="Renew date"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            ref="accreditationDate"
                            v-model="formValues.accreditedDate"
                            :max="date"
                            no-title
                            scrollable
                            @input="startMenu = false"
                        ></v-date-picker>
                      </v-menu>
                      <span class="text-gray-600 text-xs italic text-red-700">{{
                          errors[0]
                        }}</span>
                    </validation-provider>
                  </div>
                  <v-col cols="6" md="6" sm="8">
                    <v-btn
                        class="mt-9"
                        color="success"
                        elevation="1"
                        small
                        @click="addRenewal()"
                    >
                      <v-icon>mdi-autorenew</v-icon>
                      Renew
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </div>
            <v-divider></v-divider>
            <v-data-table
                :headers="renewalHeader"
                :items="renewals"
                :loading="loading"
                :server-items-length="renewals.length"
                class="elevation-1"
                loading-text="Loading... please wait"
            ></v-data-table>
          </v-card>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import {extend, ValidationProvider} from "vee-validate";
import {getUser} from "@/utils/helper";
import HrdAddAccreditor from "./hrd-add-accreditor";
import HrdDetailAccreditor from "./hrd-accreditor-detail";
import {AccreditorService} from "./accreditor.service";
import {required} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  components: {
    HrdAddAccreditor,
    HrdDetailAccreditor,
    ValidationProvider,
  },
  data() {
    return {
      search: "",
      accreditor: null,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      loading: false,
      dialog: false,
      detailDialog: false,
      renewalDialog: false,
      headers: [
        {text: "Accreditor Name", value: "accreditorName"},
        {text: "Accreditor's Geolocation", value: "region.name"},
        {text: "Accreditor's Ownership", value: "accredatorOwnership.name"},
        {text: "Accreditation Code", value: "accreditationCode"},
        {text: "Accreditor's Status", value: "isActive", align: "center"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      accreditors: [],

      startMenu: false,
      startMenu2: false,
      formValues: {
        accreditedDate: "",
        accreditedBy: null,
        cpdId: null,
        accreditorId: null,
      },
      renewalHeader: [
        {text: "Accredited Date", value: "accreditedDate"},
        {text: "Accredited By", value: "user.firstName"},
      ],
      renewals: [],
    };
  },
  async beforeMount() {
    this.fetchAccreditorList();
  },
  watch: {
    options: {
      handler() {
        this.fetchAccreditorList();
      },
      deep: true,
    },
    search: function (val) {
      this.search = val;
      this.fetchAccreditorList();
    },
  },
  computed: {
    canCreateAccreditor() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "CPD Accreditor" &&
              permission.canCreate
      );
    },
    canViewAccreditor() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "CPD Accreditor" && permission.canRead
      );
    },
  },
  methods: {
    AddAccreditor() {
      this.accreditor = null;
      this.dialog = true;
      this.title = "Add Accreditor";
    },
    viewAccreditor(item) {
      this.accreditor = item;
      this.detailDialog = true;
      this.title = "Accreditor Detail";
    },
    canEditAccreditor(id, accId) {
      return (getUser().data?.userRoles?.roleName == "System admins" ||
          (getUser().permissions.some(
                  (permission) =>
                      permission.menuItem.menuItemName == "Accreditor" &&
                      permission.canUpdate &&
                      (getUser().data?.['id'] == id ||
                          getUser().data?.['accreditorId'] == accId))
          ));
    },
    editAccreditor(item) {
      this.accreditor = item;
      this.title = "Edit Accreditor";
      this.dialog = true;
      //   this.changeTAccreditorUsedNo = 0;
      //   this.changeAccreditorOwnerNo = 0;
    },
    canRenewAccreditor() {
      return (getUser().data?.userRoles?.roleName == "System admins");
    },
    renewAccreditor(item) {
      this.accreditor = item;
      this.title = "Renew Accreditor";
      this.renewalDialog = true;
      this.formValues.accreditorId = item.id;
      this.fetchRenewalList(item.id);
    },
    closeDialog() {
      this.dialog = false;
      this.detailDialog = false;
      this.renewalDialog = false;
      this.fetchAccreditorList();
    },
    async registerOrUpdateAccreditor(accreditor) {
      let res = null;
      const user = JSON.parse(localStorage.getItem('user'));
      const userId = user.data.id;

      if (accreditor.editMode) {
        res = await AccreditorService.update(accreditor.id, accreditor);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchAccreditorList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to update accreditor, please try again");
        }
      } else {

        accreditor.createdById = userId;
        res = await AccreditorService.create(accreditor);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.formValues.accreditorId = res.data.data.id;
              this.formValues.accreditedDate = res.data.data.accreditationDate;
              await AccreditorService.addRenewal(this.formValues)
                  .then(this.fetchAccreditorList());
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create accreditor, please try again");
        }
      }

    },
    async fetchAccreditorList() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      const res = await AccreditorService.getAccreditorListWP(
          page,
          itemsPerPage,
          this.search
      );
      if (res.status === 200) {
        this.loading = false;
        this.accreditors = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Accreditors, Please try Again!"
        );
      }
    },
    async fetchRenewalList(id) {
      this.loading = true;
      const res = await AccreditorService.getRenewals(id);
      if (res.status === 200) {
        this.loading = false;
        this.renewals = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Renewals, Please try Again!"
        );
      }
    },
    async addRenewal() {
      const res = await AccreditorService.addRenewal(this.formValues);
      if (res.status === 200) {
        const accreditationDate = this.formValues.accreditedDate;
        AccreditorService.update(this.accreditor.id, {"accreditationDate": accreditationDate})
            .then(this.$toast.success(res.data.message))
            .then(this.closeDialog());
      } else {
        this.$toast.error(res.data.message);
      }
    },
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
  },
};
</script>